/*
 * @Description:
 * @Version:
 * @Autor: baichenhui
 * @Date: 2021-08-25 11:37:19
 */
function apiUrlHeader () {
  if (process.env.NODE_ENV === 'development') {
    return 'https://hyhis-lingdong-web.yikangbao.com.cn'
  }
  return `//${location.hostname}`
}

function setWindowStore (at) {
  window.g_public_rsa_key = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsqhcE4HaqdEOVSMUPbvFxQMN0HvYezgFbnEMzXBcgQ7dBzXp1GV5ZWEELzbIrQsBCwxLygzArparzF2HT8RxRiSCJIvQUBX/eBeucfozZJ1HW8uE/AC1N9O2A8Zdu1VXDgHVKgJ8Rtgoq2+k6AP9XQo2h7vYtlKezCX6Yso9zbYRpArmhuUt0fhxDkbbVYThOX+49tadm+n6rTpt3094ND9p1d76mB+35WIlCbYtm22QCrGG75VgPFNCZ6emjM3hWS2mXSXBi7+rr/WsPhRv3WBCnJlUHa4ldFZJed8vNOPxLUCehWg50XGW0QqqVpf/RX1weJcv+IDK6JdYOGAYFQIDAQAB'
  window.store = {
    // host: 'https://hyhis-lingdong-api.yikangbao.com.cn/',
    host: apiUrlHeader(),
    access_token: at ||
    '5b5387cb-cf81-46b6-9a73-13df1a15008d'
  }
}

export { apiUrlHeader, setWindowStore }
